<div class="booking-offer-page-loader" *ngIf="vm.loading && !vm.initialized && !vm.loadError">
	<loader-overlay></loader-overlay>
</div>

<div class="o-grid o-grid--wrap" *ngIf="vm.loadError">
	<div class="o-grid__cell o-grid__cell--w-100 u-no-p">
		<section class="c-section c-section--first c-section--last c-section--open c-section--static">
			<div class="c-section__header">
				<h1 class="c-section__title c-section__title--sm">{{ 'Common.Error_Default' | translate }}</h1>
			</div>
			<div class="c-section__content">
				<div class="o-grid">
					<div class="o-grid__cell c-cell u-no-mt">
						<div class="c-card">
							<div class="c-content">
								<p class="c-text">{{ 'Common.Error_Default' | translate }}</p>
							</div>
						</div>
					</div>
				</div>
				<div class="o-grid u-ost-md">
					<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--right">
						<a id="bookingOfferLoadErrorBackButton" [routerLink]="vm.backUrl" class="c-button c-button--link c-button--lg">{{ 'Booking.Button.Back' | translate }}</a>
					</div>
				</div>
			</div>
		</section>
	</div>
</div>

<div class="o-grid o-grid--wrap" *ngIf="vm.initialized">
	<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-33@md-and-up u-no-p">
		<section class="c-section c-section--first" panel [isOpen]="vm.isOpen?.service">
			<div class="c-section__header">
				<h1 class="c-section__title c-section__title--sm">{{ 'Booking.Title.Service' | translate }}</h1>
			</div>
			<div class="c-section__content">
				<div class="o-grid o-grid--wrap">
					<div class="o-grid__cell c-cell u-no-mt">
						<card-service [service]="vm.booking.service" [isMinimal]="true"></card-service>
					</div>
				</div>
			</div>
		</section>
	</div>

	<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-67@md-and-up u-no-p">
		<section class="c-section c-section--last" [ngClass]="{ 'c-section--error': (vm.submitted && mainForm.invalid) }" panel [isOpen]="vm.isOpen?.overview">
			<div class="c-section__header">
				<h2 class="c-section__title c-section__title--sm">{{ 'Booking.Overview' | translate }}</h2>
			</div>
			<div class="c-section__content" *ngIf="vm.booking">
				<loader-overlay *ngIf="!vm.walletProcessed"></loader-overlay>
				<div class="o-grid" *ngIf="vm.walletProcessed">
					<div class="o-grid__cell o-grid__cell--w-100 u-no-p@up-to-md">
						<div class="c-card">
							<div class="c-content">
								<div class="o-grid o-grid--wrap">
									<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-45@md-and-up u-no-p">
										<div class="o-grid">
											<div class="o-grid__cell u-no-pl">
												<p class="c-text c-text--gray u-no-wrap">{{ 'Booking.Date' | translate }}</p>
											</div>
											<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
												<p class="c-text c-text--right c-text--s2">{{ vm.booking.date }}</p>
											</div>
										</div>
										<div class="o-grid" *ngIf="vm.booking.start && vm.booking.end">
											<div class="o-grid__cell u-no-pl">
												<p class="c-text c-text--gray u-no-wrap">{{ 'Booking.Time' | translate }}</p>
											</div>
											<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
												<p class="c-text c-text--right c-text--s2">{{ vm.booking.start }} - {{ vm.booking.end }} ({{ vm.booking.duration }} {{ 'Units.Minutes' | translate | lowerCase }})</p>
											</div>
										</div>
									</div>
									<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-10@md-and-up u-ost-md@up-to-md">
										<div class="c-divider c-divider--v"></div>
									</div>
									<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-45@md-and-up u-no-p">
										<div class="o-grid">
											<div class="o-grid__cell u-no-pl">
												<p class="c-text c-text--gray u-no-wrap">{{ 'Booking.Private_Wallet_Balance' | translate }}</p>
											</div>
											<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
												<p class="c-text c-text--right">{{ vm.booking.privateWalletBalance || 0 }}{{ vm.booking.currency }}</p>
											</div>
										</div>
										<div class="o-grid">
											<div class="o-grid__cell u-no-pl">
												<p class="c-text c-text--gray u-no-wrap">Employer covered</p>
											</div>
											<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
												<p class="c-text c-text--right">{{ vm.getBookingOfferEmployerCoveredAmount() }}{{ vm.booking.currency }}</p>
											</div>
										</div>
										<div class="o-grid">
											<div class="o-grid__cell u-no-pl">
												<p class="c-text c-text--lg c-text--bold c-text--uppercase u-no-wrap">{{ 'Booking.Total' | translate }}</p>
											</div>
											<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
												<p class="c-text c-text--lg c-text--bold c-text--right c-text--main">{{ vm.getBookingOfferTotalCost() }}{{ vm.booking.currency }}</p>
											</div>
										</div>
									</div>
								</div>
							</div>

							<div class="c-content c-content--wrapper" *ngIf="vm.shouldShowPaymentMethodSelection()">
								<div class="o-grid o-grid--wrap o-grid--center-v u-osl-sm">
									<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed@md-and-up o-grid__cell--slim u-osb-sm">
										<label class="c-radio">
											<input type="radio" name="bookingOfferPaymentMethod" [value]="'stripe'" [(ngModel)]="vm.offerPaymentMethod" (change)="vm.handleBookingOfferPaymentMethodChange()">
											<span class="c-radio__label">Credit card</span>
										</label>
									</div>
									<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed@md-and-up o-grid__cell--slim u-osb-sm">
										<label class="c-radio">
											<input type="radio" name="bookingOfferPaymentMethod" [value]="'banklinks'" [(ngModel)]="vm.offerPaymentMethod" (change)="vm.handleBookingOfferPaymentMethodChange()">
											<span class="c-radio__label">Banklinks</span>
										</label>
									</div>
								</div>
							</div>

							<div class="c-content c-content--wrapper booking-offer-payment-area" [hidden]="vm.leftToPay <= 0 || !vm.isStripeVisible()">
								<div class="o-grid__cell u-no-pl booking-offer-payment-label u-osl-md">
									<p class="c-text c-text--gray u-no-wrap">{{ 'Booking.Enter_Credit_Card' | translate }}</p>
								</div>
								<div class="o-grid__cell o-grid__cell--w-100">
									<form id="bookingOfferPaymentForm" class="booking-offer-stripe-form">
										<div id="card-element" class="booking-offer-card-element"></div>
										<p id="card-error" role="alert" class="booking-offer-payment-error"></p>
									</form>
									<p class="booking-offer-payment-error" *ngIf="vm.stripeLoadError">{{ 'Common.Error_Default' | translate }}</p>
								</div>
								<loader-overlay *ngIf="vm.stripeLoading"></loader-overlay>
							</div>

							<div class="c-content c-content--wrapper booking-offer-payment-area" *ngIf="vm.shouldShowBanklinks()">
								<list-banklinks [bookingOffer]="vm.booking" [(reloadNeeded)]="vm.banklinksReloadNeeded" [(banklinks)]="vm.banklinks" [(activeBanklink)]="vm.banklink" [(isLoading)]="vm.banklinksLoading" [(loadError)]="vm.banklinksLoadError" [isRequired]="true" *ngIf="vm.booking.id"></list-banklinks>
								<p class="c-text c-text--s3 u-ost-sm" *ngIf="!vm.banklink && !vm.banklinksLoading && !vm.banklinksLoadError">{{ 'Booking.Choose_Payment_Method' | translate }}</p>
								<p class="booking-offer-payment-error" *ngIf="vm.banklinksLoadError">{{ 'Common.Error_Default' | translate }}</p>
								<loader-overlay *ngIf="vm.banklinksLoading"></loader-overlay>
							</div>

							<form class="c-form" name="vm.form" [formGroup]="mainForm">
								<div class="c-content">
									<div class="c-form__group u-osb-sm" [ngClass]="{ 'c-form__group--error': (vm.submitted && mainForm.get('termsCheckbox').invalid) }">
										<label class="c-checkbox">
											<input id="termsCheckbox" formControlName="termsCheckbox" type="checkbox" name="terms">
											<span id="termsConsentLabel" [innerHTML]="vm.termsConsent"></span>
										</label>
									</div>
									<div class="c-form__group u-osb-sm" [ngClass]="{ 'c-form__group--error': (vm.submitted && mainForm.get('ppCheckbox').invalid) }">
										<label class="c-checkbox">
											<input id="ppCheckbox" formControlName="ppCheckbox" type="checkbox" name="pp">
											<span id="ppConsentLabel" [innerHTML]="vm.ppConsent"></span>
										</label>
									</div>
									<div class="c-form__group u-osb-sm" [ngClass]="{ 'c-form__group--error': (vm.submitted && mainForm.get('dataProcessingCheckbox').invalid) }" *ngIf="vm.dataProcessingAcceptedVisible">
										<label class="c-checkbox">
											<input id="dataProcessingCheckbox" formControlName="dataProcessingCheckbox" type="checkbox" name="processing">
											<span id="dataProcessingConsentLabel">{{ 'Modal.Content.Data_Processing' | translate }} <span *ngIf="vm.dataProcessingAcceptedRequired">*</span></span>
										</label>
									</div>
									<div class="c-form__group u-osb-sm" [ngClass]="{ 'c-form__group--error': (vm.submitted && mainForm.get('dataStorageTimeCheckbox').invalid) }" *ngIf="vm.dataStorageTimeAcceptedVisible">
										<label class="c-checkbox">
											<input id="dataStorageTimeCheckbox" formControlName="dataStorageTimeCheckbox" type="checkbox" name="storageTime">
											<span id="dataStorageTimeConsentLabel">{{ 'Modal.Content.Data_Storage_Time' | translate }} <span *ngIf="vm.dataStorageTimeAcceptedRequired">*</span></span>
										</label>
									</div>
									<div class="c-form__group u-osb-sm" [ngClass]="{ 'c-form__group--error': (vm.submitted && mainForm.get('dataSharingCheckbox').invalid) }" *ngIf="vm.dataSharingAcceptedVisible">
										<label class="c-checkbox">
											<input id="dataSharingCheckbox" formControlName="dataSharingCheckbox" type="checkbox" name="storageTime">
											<span id="dataSharingConsentLabel">{{ 'Modal.Content.Data_Sharing_Accepted' | translate }} <span *ngIf="vm.dataSharingAcceptedRequired">*</span></span>
										</label>
									</div>
									<div *ngIf="vm.gdprDisclaimerVisible">
										<item-notification icon="attention" [text]="vm.gdprDisclaimerTranslated" [theme]="5"></item-notification>
									</div>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		</section>
	</div>

	<div class="o-grid__cell o-grid__cell--w-100 u-no-p" *ngIf="!vm.gdprDisclaimerVisible">
		<div class="o-grid u-ost-md">
			<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed@md-and-up o-grid__cell--right">
				<p class="c-text c-text--sm">{{'Modal.Content.YouCanAlwaysWithdraw' | translate}} <a [routerLink]="['/consents']" target="_blank" (click)="$event.stopPropagation()">{{ 'Components.Header.Button.Manage_Consents' | translate }}</a></p>
			</div>
		</div>
	</div>

	<div class="o-grid__cell o-grid__cell--w-100 u-no-p">
		<div class="o-grid u-ost-md">
			<div class="o-grid__cell u-hidden@up-to-md"></div>
			<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--right u-hidden@up-to-md">
				<a id="bookingCheckoutBackButton" [routerLink]="vm.booking.backUrl" class="c-button c-button--link c-button--lg">{{ 'Booking.Button.Back' | translate }}</a>
			</div>
			<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed@md-and-up o-grid__cell--right" *ngIf="vm.leftToPay <= 0">
				<button id="bookingOfferAcceptButton" type="button" class="c-button c-button--s2 c-button--fit c-button--lg" (click)="vm.acceptBookingOffer()" [disabled]="vm.isProcessing || !vm.booking?.id">{{ 'Booking.Button.Confirm' | translate }}</button>
			</div>
			<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed@md-and-up o-grid__cell--right" *ngIf="vm.leftToPay > 0">
				<button id="bookingOfferPaymentButton" type="button" class="c-button c-button--s2 c-button--fit c-button--lg" (click)="vm.handlePayment()" [disabled]="vm.isPaymentDisabled()">{{ 'Booking.Button.Confirm' | translate }}</button>
			</div>
		</div>
	</div>
</div>
